import React, { useEffect, useState } from 'react';
import BulletinMessagesProvider from '../../../context/bulletin-messages';
import MessagesReviewModal from './MessagesReviewModal';
import ValidationModal from './ValidationModal';
import { useBulletinResponse } from '../../../context/bulletin';

interface ValidationSectionProps {
  show: boolean;
  onClose: () => void;
}

function ValidationSection({ onClose, show }: ValidationSectionProps) {
  const {
    bulletin: { has_messages: hasMessages },
  } = useBulletinResponse();
  const [messagesReviewModal, setMessagesReviewModal] = useState(
    show && hasMessages,
  );
  const [validationModalVisible, setValidationModalVisible] = useState(
    show && !hasMessages,
  );

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMessagesReviewModal(show && hasMessages);
    setValidationModalVisible(show && !hasMessages);
  }, [show]);

  return (
    <BulletinMessagesProvider>
      <MessagesReviewModal
        show={messagesReviewModal}
        closeAction={onClose}
        onValidate={() => {
          setMessagesReviewModal(false);
          setValidationModalVisible(true);
        }}
      />
      <ValidationModal show={validationModalVisible} onClose={onClose} />
    </BulletinMessagesProvider>
  );
}

export default ValidationSection;
